import { styled } from '@glitz/react';
import { ArrowRight } from 'webapp/components/icons';
import { Document, type StyleDecorators } from '@avensia/excite-contentful';
import * as React from 'react';
import { createMinLargeViewportDecorator } from 'webapp/viewport';
import Link from 'webapp/components/Link';

type Props = {
  promo: NordicNest.Api.PromoBlockApiModel;
  onClick: () => void;
};

export const Promo = ({ promo, onClick }: Props) => {
  if (promo.message && promo.message.elements) {
    return (
      <Base css={{ backgroundColor: promo.backgroundColor, color: promo.textColor }}>
        <PromoLink to={promo.path} onClick={onClick}>
          <Document elements={promo.message.elements} styleDecorators={styles} />
          <ArrowRight />
        </PromoLink>
      </Base>
    );
  }
  return null;
};

const styles: StyleDecorators = {
  p: styled(
    createMinLargeViewportDecorator({
      margin: {
        bottom: 0,
      },
    }),
    {
      fontSize: t => t.fontSize.xs,
      margin: {
        bottom: 0,
      },
    },
  ),
};

const PromoLink = styled(Link, {
  height: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: t => t.spacing.m,
  alignItems: 'center',
  ':hover': {
    color: t => t.secondary.text,
  },
  padding: { xy: t => t.spacing.s },
});

const Base = styled.li({
  margin: { bottom: t => t.spacing.s },
});
